module.exports = __webpack_public_path__ + "img/Veritas_closed.e70e67b2.png";